import SignupAsPopup from "components/popups/SignupAsPopup";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AdvertisementSection from "sections/homepage/advertisementSection/AdvertisementSection";
import ArtYerkirSection from "sections/homepage/artYerkirSection/ArtYerkirSection";
import EventsSection from "sections/homepage/eventsSection/EventsSection";
import GalleriesSection from "sections/homepage/galleriesSection/GalleriesSection";
import GuideSection from "sections/homepage/guideSection/GuideSection";
import HeroSection from "sections/homepage/heroSection/HeroSection";
import HistoryThroughFacesSection from "sections/homepage/historyThroughFacesSection/HistoryThroughFacesSection";
import MuseumSection from "sections/homepage/museumSection/MuseumSection";
import PaintingsSection from "sections/homepage/paintingsSection/PaintingsSection";
import PremierGallerySection from "sections/homepage/premierGallerySection/PremierGallerySection";
import SculpturesSection from "sections/homepage/sculpturesSection/SculpturesSection";
import StoryOfArtwork from "sections/homepage/storyOfArtwork/StoryOfArtwork";

const Homepage = () => {
  const location = useLocation();
  const [showSignupAsPopup, setShowSignupAsPopup] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    if (location.search.includes("userid")) {
      setShowSignupAsPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <HeroSection />
      <HistoryThroughFacesSection />
      <StoryOfArtwork />
      <PaintingsSection />
      <SculpturesSection />
      <AdvertisementSection />
      <EventsSection />
      <GalleriesSection />
      <MuseumSection />
      <ArtYerkirSection />
      <GuideSection />
      <PremierGallerySection />
      {showSignupAsPopup ? (
        <SignupAsPopup
          showSignupAsPopup={showSignupAsPopup}
          setShowSignupAsPopup={setShowSignupAsPopup}
        />
      ) : null}
    </div>
  );
};

export default Homepage;
